import { selectors as catalogSelectors } from 'dux/catalog';
import { selectors as instanceSelectors } from 'dux/instances';
import { selectors as userSelectors } from 'dux/user';
import { actionCreators } from 'dux/createInstance';
import { connect } from 'react-redux';
import AddRegionForm from './AddRegionForm';

const mapStateToProps = (state) => ({
  catalog: catalogSelectors.getCatalogState(state),
  userRoles: userSelectors.getIdentityState(state).roles,
  getServiceSubtypeIdByName: catalogSelectors.getServiceSubtypeIdByName(state),
  getUnusedCockroachDBRegions: instanceSelectors.getUnusedCockroachDBRegions(state),
  getValidFlavorsByInstanceId: instanceSelectors.getValidFlavorsByInstanceId(state),
  getServiceSubtypeNameByInstanceId: instanceSelectors.getServiceSubtypeNameByInstanceId(state),
});

const mapDispatchToProps = {
  createInstance: actionCreators.createInstance,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddRegionForm);
